(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-optimisation"]) return;
  try {
    
  (function ThemeEditor() {
    'use strict';

    document.addEventListener('shopify:section:select', select);
    document.addEventListener('shopify:section:load', load);
    document.addEventListener('shopify:section:deselect', deselect);

    function select(evt) {
      if (evt.detail.sectionId !== 'app-optimisation') return;

      let node = document.querySelector('sd-app-list');
      if (node) node.removeAttribute('style');
      if (customElements.get('sd-app-list')) return;
      defineElement();
      initCopyEvents(node.shadowRoot);
    }

    function load(evt) {
      if (evt.detail.sectionId !== 'app-optimisation') return;

      let shadowRoot = document.querySelector('sd-app-list').shadowRoot;
      let nodes = Array.prototype.slice.call(shadowRoot.children);
      nodes.forEach(node => node.parentNode.removeChild(node));
      shadowRoot.appendChild(templateContent());
      initCopyEvents(shadowRoot);
    }

    function deselect(evt) {
      if (evt.detail.sectionId !== 'app-optimisation') return;

      let node = document.querySelector('sd-app-list');
      if (node) node.style.display = 'none';
    }

    function defineElement() {
      customElements.define('sd-app-list',
        class extends HTMLElement {
          constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'}).appendChild(templateContent());
          }
        }
      );
    }

    function templateContent() {
      let template = document.getElementById('sd-app-list-template');
      return template.content.cloneNode(true);
    }

    function initCopyEvents(shadowRoot) {
      let nodes = Array.prototype.slice.call(shadowRoot.querySelectorAll('[data-clipboard]'));
      nodes.forEach(node => node.addEventListener('click', copyText));
    }

    function copyText() {
      navigator.clipboard.writeText(this.getAttribute('data-clipboard'));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }

                initSlider()
            })
            .catch(e => {
              console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();
})();
